import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAddresses } from '../context/AddressContext';
import AddressAutocomplete from '../components/AddressAutocomplete';
import api from '../api';
import './Addresses.css';

export default function Addresses() {
  const { id: packageId } = useParams();
  const { addresses, setAddresses } = useAddresses();
  const [saved, setSaved] = useState(false);
  const [mapsLoaded, setMapsLoaded] = useState(!!window.google);

  useEffect(() => {
    api.get(`/addresses/${packageId}`).then(res => {
      if (res.data.addresses.length > 0) {
        setAddresses(res.data.addresses);
      } else {
        setAddresses(['']);
      }
    }).catch(() => {
      setAddresses(['']);
    });

    if (!window.google) {
      api.get('/config/google-maps-key').then(res => {
        if (!res.data.apiKey) return;
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${res.data.apiKey}&libraries=places`;
        script.async = true;
        script.onload = () => setMapsLoaded(true);
        document.head.appendChild(script);
      });
    }
  }, [packageId]);

  const updateAddress = (index, value) => {
    const updated = [...addresses];
    updated[index] = value;
    setAddresses(updated);
    setSaved(false);
  };

  const addAddress = () => {
    setAddresses([...addresses, '']);
    setSaved(false);
  };

  const removeAddress = (index) => {
    if (addresses.length <= 1) return;
    setAddresses(addresses.filter((_, i) => i !== index));
    setSaved(false);
  };

  const saveAddresses = async () => {
    const filtered = addresses.filter(a => a.trim());
    if (filtered.length === 0) return;
    try {
      await api.post(`/addresses/${packageId}`, { addresses: filtered });
      setAddresses(filtered);
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      console.error('Failed to save:', err);
    }
  };

  return (
    <div className="addresses-page">
      <h1 className="page-title">Property Addresses</h1>

      <div className="address-list">
        {addresses.map((addr, i) => (
          <div key={i} className="address-row">
            {mapsLoaded ? (
              <AddressAutocomplete
                value={addr}
                onChange={val => updateAddress(i, val)}
                placeholder="Enter property address"
              />
            ) : (
              <input
                type="text"
                placeholder="Enter property address"
                value={addr}
                onChange={e => updateAddress(i, e.target.value)}
                className="address-input"
              />
            )}
            {addresses.length > 1 && (
              <button className="btn-icon btn-remove" onClick={() => removeAddress(i)} title="Remove">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                  <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1 0-2h3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1h3a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118z"/>
                </svg>
              </button>
            )}
          </div>
        ))}
      </div>

      <button className="btn-add" onClick={addAddress}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
        </svg>
        Add Address
      </button>

      <button className="btn-primary" onClick={saveAddresses}>
        {saved ? 'Saved!' : 'Save Addresses'}
      </button>
    </div>
  );
}
